import { useNavigate } from "react-router-dom";
import { useSettingsStore } from "../../../../stores/Utils/settings";
import { useTokenContext } from "../../../../context/tokenContext";
import { useClickOutside } from "../../../../hooks/useClickOutside";
import "../../../../css/animations.css";

const Settings = () => {
  const { setShowSettings, showSettings } = useSettingsStore();
  const { isSuperAdmin } = useTokenContext();
  const navigate = useNavigate();

  // Hook
  useClickOutside([
    {
      elementId: "modal-Settings",
      callback: () => setShowSettings(false),
    },
  ]);

  return (
    <div className="">
      {showSettings && (
        <div
          className={`fixed bottom-16 left-2 right-2 z-40 h-[150px] rounded-xl bg-white p-4 shadow-2xl sm:absolute sm:bottom-auto sm:left-14 sm:right-auto sm:top-64 sm:w-[300px] xl:w-[400px] ${
            isSuperAdmin === 1 ? " overflow-y-scroll" : ""
          }`}
          id="modal-Settings"
        >
          <p className="text-center font-BarlowCondensed text-lg w-full bg-yellow-trio rounded-md ">
            Parametrage :
          </p>
          {isSuperAdmin === 1 ? (
            <button
              className="flex justify-start items-center mt-4 w-full learn-more"
              onClick={() => {
                setShowSettings(false);
                navigate("/superadmin/dashboard");
              }}
            >
              <span className="circle" aria-hidden="true">
                <span className="icon arrow"></span>
              </span>
              <p className="text-md text-grey-trio button-text">Super admin</p>
            </button>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default Settings;
